// Co-Authored-By: AI-Assisted | updated: 2026-10-29 11:03:52
import { useNavigate } from "react-router-dom";
import { Row, Col, Modal, Form, Input, Button, App } from "antd";
import { resetPassword } from "./api";
import { storage } from '@/utils/storage';
import { useI18n } from '@/i18n';
import "./index.less";
export default function Index(props) {
  const { message } = App.useApp();
  const { closePassModal } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const $t = useI18n('component.password.language');

  async function changePassWord(val) {
    const { data: { code }, } = await resetPassword(val);
    if (+code === 0) {
      closePassModal();
      message.success($t("Password Changed Successfully, Please Login Again"), 0.5, () => {
        storage.safeClear();
        navigate("/login", { replace: true });
      });
    }
  }
  const handleCancel = () => {
    closePassModal();
  };
  const onFinish = (val) => {
    changePassWord(val);
  };

  return (
    <Modal title={$t('Reset Password')} open onCancel={handleCancel} footer={null} width={613} right >
      <div style={{ marginTop: 46 }}></div>
      <Form style={{ width: 552 }} name="change_password" labelCol={{ span: 4 }} wrapperCol={{ span: 24 }} onFinish={onFinish} autoComplete="off" form={form} >
        <Form.Item label={$t("Current Password")} name="password" rules={[{ required: true, message: $t("Please Enter Current Password") }]} >
          <Input.Password visibilityToggle={true} maxLength={30} placeholder={$t("Please Enter Current Password")} />
        </Form.Item>
        <Form.Item label={$t("New Password")} name="new_password" rules={[{ required: true, message: $t('New Password') }, () => ({
          validator(_, value) {
            if (!value) {
              return Promise.resolve();
            }
            const invalidChars = [...new Set(value.replace(/[A-Za-z0-9!@#$_\-*]/g, ''))];
            if (invalidChars.length > 0) {
              return Promise.reject(new Error($t('Invalid character: ') + invalidChars.join(' ')));
            }
            if (!(/^[A-Za-z0-9!@#$_*-]{6,16}$/.test(value) && [/[a-z]/, /[A-Z]/, /\d/, /[!@#$_*-]/].filter(r => r.test(value)).length >= 3)) {
              return Promise.reject(new Error($t('6-16 characters, must include at least 3 of: uppercase, lowercase, digit, or special character')));
            }
            return Promise.resolve();
          },
        }),
        ]}
        >
          <Input.Password maxLength={16} visibilityToggle={true} placeholder={$t('6-16 characters, must include at least 3 of: uppercase, lowercase, digit, or special character')} />
        </Form.Item>
        <Form.Item label={$t("Confirm Password")} name="re_new_password" required rules={[{ required: true, message: $t("Confirm Password") }, ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue("new_password") === value) {
              return Promise.resolve();
            }
            return Promise.reject($t("Passwords Do Not Match"));
          },
        }),
        ]}
        >
          <Input.Password visibilityToggle={true} maxLength={16} placeholder={$t("Confirm Password")} />
        </Form.Item>
        <Form.Item>
          <Row><Col offset={8} span={8}><Button block type="primary" htmlType="submit">{$t("Save")}</Button></Col></Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};